import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'td[CustomCheck]',
  standalone: true,
  imports: [
    CommonModule
  ],
  template: `
    <i [ngClass]="checked ? 'pi pi-check-circle': 'pi pi-times-circle'" style="font-size: 1.25rem; color: #000;"></i>
  `
})
export class CustomTableCheck {
  @Input() checked !: boolean;
}
